module.exports = __webpack_public_path__ + "img/2df298322f9e621228c22b1391cfb574.e49e7270.jpg";